(function(MapFacilities) {
    'use strict';

    var Way2web = window.Way2web || {};

    MapFacilities.zoomLevel = {
        start: 3,
        userLocation: 11,
        card: 16
    };
    MapFacilities.container = false;
    MapFacilities.fetchURL = false;
    MapFacilities.cardURL = false;
    MapFacilities.loading = false;

    MapFacilities.filters = {
        'term': '',
        'businessline': '',
        'country': ''
    };

    MapFacilities.map = false;
    MapFacilities.clusterer = false;
    MapFacilities.mapOptions = false;
    MapFacilities.locationtrigger = false;

    MapFacilities.latLongs = [];
    MapFacilities.markers = [];
    MapFacilities.markersTypeahead = [];

    MapFacilities.checkedBusinessLines = [];

    MapFacilities.init = function() {
        var facilities = $('.js-facilities');

        if (!facilities.length) {
            return;
        }

        MapFacilities.container = facilities;
        MapFacilities.setMapHeight();

        MapFacilities.fetchURL = MapFacilities.container.data('fetch-url');
        if (typeof MapFacilities.fetchURL === 'undefined' || MapFacilities.fetchURL === '') {
            throw 'facilities fetch url not found';
        }
        MapFacilities.cardURL = MapFacilities.container.data('card-url');
        if (typeof MapFacilities.cardURL === 'undefined' || MapFacilities.cardURL === '') {
            throw 'facilities card url not found';
        }

        // init options
        MapFacilities.mapOptions = {
            zoom: MapFacilities.zoomLevel.start,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: Way2web.MapShared.style,

            disableDefaultUI: true,
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.MEDIUM,
                position: google.maps.ControlPosition.LEFT_BOTTOM
            }
        };

        // init map
        MapFacilities.map = new google.maps.Map(
            MapFacilities.container.get(0),
            MapFacilities.mapOptions
        );

        if (verge.mq(Way2web.config.breakpoints.desk)) {
            MapFacilities.initToggles();
        } else {
            MapFacilities.initBusinessLines();
        }

        MapFacilities.loadFacilities();
        MapFacilities.userLocation();
    };

    MapFacilities.loadFacilities = function() {
        $.post(MapFacilities.fetchURL, MapFacilities.filters, function(data) {
            $.each(data, function(key, facility) {
                var latLng = new google.maps.LatLng(facility.lat, facility.long);
                MapFacilities.latLongs.push(latLng);

                if (facility.id && facility.lat && facility.long) {
                    var marker = new google.maps.Marker({
                        id: facility.id,
                        businessLineId: facility.blId,
                        position: latLng,
                        icon: wpData.uriAssets + 'img/markers/' + facility.col + '.png'
                    });

                    marker.addListener('click', function() {
                        MapFacilities.showCard(facility.id, MapFacilities.zoomLevel.card);
                    });

                    MapFacilities.markers[facility.id] = marker;

                    var markerTypeahead = {
                        id: facility.id,
                        name: facility.name
                    };
                    MapFacilities.markersTypeahead.push(markerTypeahead);
                }
            });

            MapFacilities.initAutocomplete();
            MapFacilities.initCountryDropdown();
            MapFacilities.drawCluster();
            MapFacilities.fitAllMarkers();

        });
    };

    MapFacilities.drawCluster = function() {
        // set a local array that will only contain markers we want in our clusterer.
        var filteredMarkers = [];
        $.each(MapFacilities.markers, function(i, marker) {
            // only add markers with a businessline in our checked businessline array
            if (marker && marker.businessLineId && MapFacilities.checkedBusinessLines.indexOf(marker.businessLineId) > -1) {
                filteredMarkers.push(marker);
            }
        });

        if (!MapFacilities.clusterer) {
            MapFacilities.clusterer = new MarkerClusterer(MapFacilities.map, filteredMarkers, Way2web.MapShared.clusterStyle);
        } else {
            MapFacilities.clusterer.clearMarkers();
            MapFacilities.clusterer.addMarkers(filteredMarkers);
        }
    };

    MapFacilities.initToggles = function() {
        // add toggles to map
        var toggles = document.getElementsByClassName('js-facility-toggles')[0];
        MapFacilities.map.controls[google.maps.ControlPosition.TOP_CENTER].push(toggles);

        MapFacilities.initBusinessLines();

        // handle on click logic
        $('.js-facility-toggle').on('click', function() {
            var toggle = $(this);
            var state = toggle.data('state');
            var businessLineId = toggle.data('businessline-id');

            if (state == 'checked') {
                toggle.data('state', 'unchecked');
                toggle.removeClass('map__toggle--checked');

                var indexBusinessLine = MapFacilities.checkedBusinessLines.indexOf(businessLineId);
                MapFacilities.checkedBusinessLines.splice(indexBusinessLine, 1);
            } else {
                toggle.data('state', 'checked');
                toggle.addClass('map__toggle--checked');
                MapFacilities.checkedBusinessLines.push(businessLineId);
            }

            MapFacilities.drawCluster();
        });
    };

    // push active businesslines in the array first
    MapFacilities.initBusinessLines = function() {
        $('.js-facility-toggle').each(function() {
            var toggle = $(this);
            var state = toggle.data('state');
            var businessLineId = toggle.data('businessline-id');

            if (state == 'checked') {
                Way2web.MapFacilities.checkedBusinessLines.push(businessLineId);
            }
        });
    };

    MapFacilities.initAutocomplete = function() {
        var facilities = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            identify: function(obj) {
                return obj.name;
            },
            local: MapFacilities.markersTypeahead
        });

        var autocomplete = $('.js-facility-autocomplete').typeahead({
            hint: true,
            highlight: true,
            minLength: 1
        }, {
            display: 'name',
            source: facilities
        });

        autocomplete.bind('typeahead:select', function(ev, suggestion) {
            MapFacilities.showCard(suggestion.id, MapFacilities.zoomLevel.card);
        });
    };

    MapFacilities.initCountryDropdown = function() {
        var dropdown = $('.js-facility-country');
        dropdown.on('change', MapFacilities.countryChanged);
    };

    MapFacilities.countryChanged = function() {
        var country = $(this).text();
        if (country !== '') {
            MapFacilities.setMapToAddress(country);
        } else {
            MapFacilities.fitAllMarkers();
        }
    };

    MapFacilities.setMapToAddress = function(address) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            'address': address
        }, MapFacilities.setGeocoderResult);
    };

    MapFacilities.setGeocoderResult = function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
            MapFacilities.map.setCenter(results[0].geometry.location);
            MapFacilities.map.fitBounds(results[0].geometry.viewport);
        }
    };

    MapFacilities.fitAllMarkers = function() {
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < MapFacilities.markers.length; i++) {
            if (MapFacilities.markers[i]) {
                bounds.extend(MapFacilities.markers[i].getPosition());
            }
        }

        MapFacilities.map.fitBounds(bounds);
    };

    MapFacilities.viewportToMarker = function(marker, zoomLevel) {
        MapFacilities.map.setCenter(marker.position);
        MapFacilities.map.setZoom(zoomLevel);
    };

    MapFacilities.userLocation = function() {

        if (!navigator.geolocation) {
            return;
        }

        MapFacilities.locationtrigger = $('.js-map-object-geolocate');

        MapFacilities.locationtrigger.attr('hidden', false);

        MapFacilities.locationtrigger.on('click', function(event) {
            event.preventDefault();

            MapFacilities.locationtrigger.addClass('is-active');

            navigator.geolocation.getCurrentPosition(MapFacilities.userLocationLocate, MapFacilities.userLocationError);
        });
    };

    MapFacilities.userLocationLocate = function(position) {
        var location = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

        MapFacilities.map.setCenter(location);
        MapFacilities.map.setZoom(MapFacilities.zoomLevel.userLocation);

        MapFacilities.locationtrigger.removeClass('is-active').blur();
    };

    MapFacilities.userLocationError = function(error) {
        var message;

        switch (error.code) {
        case 1:
            message = 'Please enable location service and try again';
            break;
        case 2:
            message = 'Your location could not be retreived please try again';
            break;
        case 3:
            message = 'Getting your location takes to long, please try again';
            break;
        }

        alert(message);

        MapFacilities.locationtrigger.removeClass('is-active').blur();
    };

    MapFacilities.showCard = function(facilityID, zoomLevel) {

        if (MapFacilities.loading) {
            return;
        }

        MapFacilities.closeCard();

        var wantedMarker = MapFacilities.markers[facilityID];
        MapFacilities.viewportToMarker(wantedMarker, zoomLevel);

        var completeURL = MapFacilities.cardURL + '&facilityID=' + facilityID;

        MapFacilities.loading = true;
        $.get(completeURL, function(data) {
            MapFacilities.loading = false;

            var cardHTML = $(data)[0];
            MapFacilities.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(cardHTML);

            $('.js-facility-close-card').on('click', function(e) {
                e.preventDefault();
                MapFacilities.closeCard();
            });
        });
    };

    MapFacilities.closeCard = function() {
        MapFacilities.map.controls[google.maps.ControlPosition.RIGHT_TOP].clear();
    };

    MapFacilities.setMapHeight = function() {
        MapFacilities.container.css('height', 'calc(100vh - ' + MapFacilities.container.offset().top + 'px)');
    };

})(window.Way2web.MapFacilities = window.Way2web.MapFacilities || {});
